import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialProjectDashboardDataState = {
  isModalVisible: false,
  title: "",
  component: null,
  patchForProject: false,
};

const projectDashboardSlice = createSlice({
  name: "projectDashboard",
  initialState: initialProjectDashboardDataState,
  reducers: {
    setProjectModalVisiblity: (state: any, action: PayloadAction<any>) => {
      Object.assign(state, action.payload);
    },
    setPatchForProject: (state: any, action: PayloadAction<any>) => {
      state.patchForProject = action.payload;
    },
  },
});

export const { setProjectModalVisiblity, setPatchForProject } = projectDashboardSlice.actions;

export const projectDashboardData = projectDashboardSlice.reducer;

export default projectDashboardSlice.reducer;
